module.exports = __webpack_public_path__ + "img/PlaceOrder.6a97e154.png";